import { Flex, Popover, Tooltip, Typography } from "antd"
import cls from "classname"

import Private from "../../../../../Components/Private"
import Icon from "../../../../../Icon"
import { getStatusIcon } from "../../../VAMP/utils/getMonitoringMonthIcon"
import { MONTH_STATUSES, STATUS_LABELS } from "../monitoringCopy"
import MonthStatusTrigger from "../MonthStrip/MonthStatusTrigger"

import "./MonthCell.less"

const { Text } = Typography

const MonthCell = ({
  month,
  lines = [],
  isCurrent,
  popover,
  isMobile = false,
  isPrivate = false
}) => {
  const { icon, variant } = getStatusIcon(month?.status)
  const isLocked = month?.status === MONTH_STATUSES.NO_STATUS

  const metricTooltip = (line, className, children) => (
    <Tooltip key={line.key} title={line.label} trigger={isMobile ? "click" : "hover"}>
      {/* role="presentation": the span is a tooltip anchor and a click sink, never a control of its
          own — the metric name it reveals is also spelled out in the cell's aria-label below. */}
      <span
        role="presentation"
        className={className}
        onClick={isMobile ? (event) => event.stopPropagation() : undefined}
      >
        {children}
      </span>
    </Tooltip>
  )

  const valueNode = (line, index) => (
    <Text
      key={line.key ?? index}
      type="secondary"
      className={cls("month-cell__value", { locked: isLocked, "has-icon": !!line.icon })}
    >
      {line.icon && metricTooltip(line, "month-cell__metric-icon", <Icon type={line.icon} />)}
      {isPrivate && index === 0 ? (
        <Private>{line.value}</Private>
      ) : line.label && !line.icon ? (
        metricTooltip(line, undefined, line.value)
      ) : (
        line.value
      )}
    </Text>
  )

  const className = cls("month-cell", { current: isCurrent, "is-mobile": isMobile })

  const metricsLabel = lines
    .filter((line) => line.label)
    .map((line) => `${line.label} ${line.value}`)
    .join(", ")

  const content = (
    <>
      <Flex align="center" gap={8}>
        <MonthStatusTrigger icon={icon} variant={variant} />
        {isMobile && <Text className="month-cell__name">{month?.month_name}</Text>}
      </Flex>
      {!isMobile && (
        <Text type="secondary" className="month-cell__name">
          {month?.month_name}
        </Text>
      )}
      <Flex vertical align={isMobile ? "flex-start" : "center"} gap={2}>
        {lines.map(valueNode)}
      </Flex>
    </>
  )

  if (!popover) return <div className={className}>{content}</div>

  return (
    <Popover
      trigger="click"
      placement="bottom"
      overlayClassName="month-popover-overlay"
      getPopupContainer={() => document.getElementById("main-layout") || document.body}
      destroyTooltipOnHide
      content={popover}
    >
      <button
        type="button"
        className={cls(className, "interactive")}
        aria-haspopup="dialog"
        aria-label={`${month?.month_name}: ${STATUS_LABELS[month?.status] ?? ""}${
          metricsLabel ? `. ${metricsLabel}` : ""
        }`}
      >
        {content}
      </button>
    </Popover>
  )
}

export default MonthCell
